import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';
import { Instances } from '../../../constants';
import { bulkDeleteUrl } from '../../../store/actions/urlShortener.action';
import { closeModal } from '../../../store/modals';
import { IStateType } from '../../../store/models/root.interface';
import { requestObjects } from '../../../store/Objects';
import BulkDeleteModal, { DispatchPropsType, BaseSeeMorePropsType } from '../organisms/bulkDeleteModal';

const mapStateToProps = (state: IStateType) => ({
    visible: state.modals.isOpen,
    id: state.modals.params,
    appid: state.modals.params?.extraParams,
    filename: state.modals.params?.extraParams
})

const mapDispatchToProps = (dispatch: any) => ({
    onClose: () => dispatch(closeModal()),
    onDelete: (id: string, appid: string, callback: (resp: any, flag: boolean) => void) => { dispatch(bulkDeleteUrl(id, appid, callback)) },
    onLoad: () => dispatch(requestObjects(Instances.bulkUrlShortenerList, undefined, { page: true }))
})

export default connect<BaseSeeMorePropsType, DispatchPropsType, unknown, IStateType>(
    mapStateToProps,
    mapDispatchToProps
)(withImmutablePropsToJS(BulkDeleteModal));
